module.exports = "## Toggle\n\nA [toggle switch](https://www.google.com/design/spec/components/selection-controls.html#selection-controls-switch)\nis used as an on/off control.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Toggle/README.md
 ** module id = 1089
 ** module chunks = 0
 **/